export const experiences = [
  {
    company: "Samsung Semiconductor",
    location: "San Jose, CA",
    role: "Test Engineer",
    period: "Sept 2022 – Dec 2024",
    highlights: [
      "Managed SSD regression testing cycles and cut execution time by 25% through Python-based automation and test plan optimization; designed and executed test plans, analyzed logs to uncover failures, and improved performance bottlenecks",
      "Rebuilt the log-parsing pipeline using internal tools, enabling 30% faster detection of critical firmware issues which resulted in a 5-week speed up in performance validation",
      "Cut analysis time by 80% by building Tableau dashboards and SQL queries to automate SSD performance reporting",
      "Mentored 3 engineers and authored internal documentation to standardize testing practices, halving onboarding time"
    ],
    tech: ["Python", "Tableau", "SQL", "Automation", "Test Engineering"]
  },
  {
    company: "Samsung Semiconductor",
    location: "San Jose, CA",
    role: "SSD Systems Engineer Intern",
    period: "June 2021 – Sept 2021",
    highlights: [
      "Built a Python tool to analyze and visualize SSD performance data, streamlining validation and improving visibility into system behavior",
      "Automated report generation in Python, reducing manual effort by 66% and improving reliability for bug detection; explored ML classifiers for failure detection and evaluated performance against existing methods",
      "Analyzed 20,000+ performance samples; identified patterns and edge cases that informed next-generation product improvements"
    ],
    tech: ["Python", "Machine Learning", "Data Analysis", "Performance Testing"]
  }
];

